###
Require NO-authentication
###
export default ({ app, store, redirect }) ->
	await app.$customerHydrated
	if store.getters['customer/isAuthenticated']
	then redirect '/account'
